module.exports = __webpack_public_path__ + "static/media/emoticon-expression-face-smiley-yummy-svgrepo-com.525474f5.svg";